import { cloneDeep } from '@apollo/client/utilities';
import { OrderSettings } from '.';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';

export class OrderSettingsInput extends OrderSettings implements EntityInput<OrderSettings> {
  forCreate(): CreateOrderSettingsInput {
    return CreateOrderSettingsInput.from(this, CreateOrderSettingsInput);
  }

  forUpdate(): UpdateOrderSettingsInput {
    return UpdateOrderSettingsInput.from(this, UpdateOrderSettingsInput);
  }

  forDelete(): DeleteOrderSettingsInput {
    return DeleteOrderSettingsInput.from(this, DeleteOrderSettingsInput);
  }

  validate() {
    return true;
  }

  hasChanges(original: OrderSettings | undefined) {
    if (!original) return true;

    if (this.prefix !== original.prefix) return true;
    if (this.suffix !== original.suffix) return true;
    if (this.digits !== original.digits) return true;
    if (this.sendPushNotificationToAssignees !== original.sendPushNotificationToAssignees) return true;

    return false;
  }

  withPrefix(prefix: string) {
    this.prefix = prefix;
    return cloneDeep(this);
  }

  withSuffix(suffix: string) {
    this.suffix = suffix;
    return cloneDeep(this);
  }

  withDigits(value: string) {
    (this.digits as any) = parseFloat(value) || 0;
    if (this.digits < 3) this.digits = 3;
    return cloneDeep(this);
  }

  withSendPushNotificationToAssignees(value: boolean) {
    this.sendPushNotificationToAssignees = value;
    return cloneDeep(this);
  }
}

export class CreateOrderSettingsInput extends forCreate(OrderSettings) {}

export class UpdateOrderSettingsInput extends forUpdate(OrderSettings) {}

export class DeleteOrderSettingsInput extends forDelete(OrderSettings) {}
